module.exports = __webpack_public_path__ + "static/media/green.d33d53f4.webp";